import { render, staticRenderFns } from "./SalemanOrBusinessPriceSetting.vue?vue&type=template&id=6f7281cd&scoped=true&"
import script from "./SalemanOrBusinessPriceSetting.vue?vue&type=script&lang=js&"
export * from "./SalemanOrBusinessPriceSetting.vue?vue&type=script&lang=js&"
import style0 from "./SalemanOrBusinessPriceSetting.vue?vue&type=style&index=0&id=6f7281cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f7281cd",
  null
  
)

export default component.exports